export default __webpack_public_path__ + "static/media/AC.5c1c2f64.svg";